export const getMonthText = (column: any) => column.title.props.children;
